import { carouselStyles } from "@insite/content-library/Components/ProductCompareCarousel";
import { css } from "styled-components";

carouselStyles.carouselContentEmptyCellGridItem = {
    width: [4, 4, 4, 2, 2],
};

carouselStyles.carouselCellGridItem = {
    width: [8, 8, 8, 10, 10],
};

carouselStyles.attributeLabelsCellGridItem = {
    width: [4, 4, 4, 2, 2],
};

carouselStyles.attributeValuesCellGridItem = {
    width: [8, 8, 8, 10, 10],
};

carouselStyles.carouselSlideInner = {
    css: css`
    img {
        max-height: 180px;
    }
    `,
};